import React, {useEffect, useState, useRef} from 'react'
import classes from './Modal.module.scss'
import VideoPlayer from 'components/App/VideoPlayer/VideoPlayer'
import {useMediaQuery} from 'react-responsive';
import globalJSON from '../../../../data/global.json';

const VideoPosters = require.context('../../../../images/components/Introduction/video_posters', true, /.*\.(gif|png|jpe?g|svg)$/i);

function Modal({show, onClose, videos, videoSelectionIndex}){

    let [screenSize, setScreenSize] = useState("mobile")
    let autoPlayVideo = useRef(false)
    let [renderVideo, setRenderVideo] = useState(false)
    let [videoIndex, setVideoIndex] = useState(0)
    let [content, setContent] = useState()
    let renderTimeout = useRef(null)
    let modalContainer = useRef(null)

    const isDesktop = useMediaQuery({
        query: `(min-width: ${classes.screenMd})`
    })

    const isTablet = useMediaQuery({
        query: `(min-width: ${classes.screenSm})`
    })
    
    function onVideoComplete(){

        if(videos[videoIndex+1] != undefined){
            setVideoIndex(videoIndex+1)
        }else{
            setVideoIndex(0)
        }
    }

    useEffect(() =>{
        if(screenSize == "desktop"){
            autoPlayVideo.current = true
        }
    },[screenSize])

    useEffect(() =>{

        let size = "mobile"

        if(isTablet)
            size = "tablet";

        if(isDesktop)
            size = "desktop";

        setScreenSize(size)
    }, [isDesktop,isTablet])

    useEffect(() =>{
        setVideoIndex(videoSelectionIndex)
    }, [videoSelectionIndex])

    useEffect(() =>{
        setContent(videos[videoIndex])
    }, [videoIndex])

    useEffect(() =>{
        setRenderVideo(false)
        if(renderTimeout.current){
            clearTimeout(renderTimeout.current);
        }
        renderTimeout.current = setTimeout(() => {
            setRenderVideo(true)
        }, 100);

        if(window.localStorage.CORTEVA_PWA_AD_COMPLETED){
            if(content  !== undefined)
                delete content.video[0]['ad-preroll'];
        }

    }, [content, show])

	return (
        (
            show
            ?
            <section ref={modalContainer} onClick={(e) => {if(e.target === modalContainer.current) onClose();}} className={`${classes.Modal}`}>
                <div className={`${classes.Modal__container}`}>
                    <a onClick={() => {onClose()}} className='subtitle_white_global'>CLOSE</a>
                    <section className={`${classes.Modal__videoWrapper}`}>
                        <div className='aspect-ratio-box'>
                            <div className="aspect-ratio-box-inside">
                            {(
                                renderVideo 
                                ?
                                    <VideoPlayer 
                                    onComplete={() => onVideoComplete()} 
                                    content={content.video} 
                                    videoImages={VideoPosters} 
                                    windowSize={screenSize} 
                                    autoPlay={autoPlayVideo.current}
                                    />
                                : 
                                ""
                            )}
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            :
            ""
        )
	)
}

export default Modal